import { Box, Snackbar, Alert } from '@mui/material';
import { LoadingSkeleton, TableTitleBox, TableBodySkeleton } from '../../common/components';
import RealStateTaxesHeader from './components/RealStateTaxesHeader';
import RealStateTaxesTable from './components/RealStateTaxesTable';
import RealStateTaxesPagination from './components/RealStateTaxesPagination';
import RealStateTaxesImportDialog from './components/RealStateTaxesImportDialog';
import { useRealStateTaxes } from './hooks/useRealStateTaxes';

/**
 * Componente principal para gestionar impuestos inmobiliarios
 * Incluye funcionalidad de exportar e importar
 */
const RealStateTaxes = () => {
  const {
    // Data de la tabla
    data,
    isLoading,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    filter,
    plans,
    groups,

    // Funciones de tabla
    handleFilter,
    handlePageChange,
    handleRowsPerPageChange,
    handleDownloadExcel,

    // Estados de importación
    selectedFile,
    tableData,
    importDialogOpen,
    importLoading,
    snackbar,

    // Funciones de importación
    handleFileUpload,
    handleImportValues,
    handleCloseImportDialog,
    handleUpload,
    handleCloseSnackbar,
  } = useRealStateTaxes();

  return (
    <Box>
      <TableTitleBox title="Contrato | Impuesto inmobiliario" />

      {/* Header con filtros, exportar e importar */}
      <RealStateTaxesHeader
        filter={filter}
        plans={plans}
        groups={groups}
        onFilter={handleFilter}
        onDownloadExcel={handleDownloadExcel}
        isLoading={isLoading}
        selectedFile={selectedFile}
        onFileUpload={handleFileUpload}
        onImportValues={handleImportValues}
      />

      {/* Tabla de datos */}
      <RealStateTaxesTable data={data} isLoading={isLoading} LoadingComponent={TableBodySkeleton} />

      {/* Paginación */}
      <RealStateTaxesPagination
        totalPages={totalPages}
        totalCount={totalCount}
        page={page}
        onPageChange={handlePageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      {/* Modal de confirmación de importación */}
      <RealStateTaxesImportDialog
        open={importDialogOpen}
        onClose={handleCloseImportDialog}
        tableData={tableData}
        loading={importLoading}
        onUpload={handleUpload}
      />

      {/* Snackbar para notificaciones */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default RealStateTaxes;
